import { createMensagem } from "@spark/services/acompanhamentos";
import React, { useState } from 'react';
import styled from 'styled-components';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { Body } from '@spark/ui-components/components/Typography';
import Icon from '@spark/ui-components/components/Icon';
import FilePreview from '@spark/ui-components/components/FilePreview';
import { Button } from '@spark/ui-components/components/Button';
import { notification } from '@spark/ui-components/utils/notification';
import { colorTextAdditional, colorBorder, colorHover } from '@spark/ui-components/theme';
import { FormContainer, FormGroup, FormButtonToolbar } from '@spark/ui-components/components/form/FormElements';
import { StyledTextarea } from '@spark/ui-components/components/form/BaseInput';
import FileInput from '@spark/ui-components/components/form/FileInput';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';

const MensagemForm = ({
  acompanhamentoId,
  onSuccess
}) => {
  const [loading, setLoading] = useState(false);
  const [conteudo, setConteudo] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();

    if (!conteudo.trim()) {
      notification.error('Digite uma mensagem');
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('conteudo', conteudo.trim());

      if (selectedFile && selectedFile.file) {
        formData.append('arquivo', selectedFile.file);
      }

      const response = await createMensagem(acompanhamentoId, formData);

      if (response && response.success) {
        notification.success('Mensagem enviada com sucesso!');
        setConteudo('');
        setSelectedFile(null);
        if (onSuccess) onSuccess();
      } else {
        const errorMessage = response?.message || 'Erro interno do servidor';
        notification.error('Erro ao enviar mensagem', errorMessage);
      }
    } catch (error) {
      console.error('Erro ao enviar mensagem:', error);
      const errorMessage = error?.response?.data?.message || error.message || 'Erro ao enviar mensagem'; // Erro tratado automaticamente pelo interceptor global do axios
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = fileData => {
    if (fileData && fileData.file) {
      if (fileData.file.size > 10 * 1024 * 1024) {
        // 10MB
        notification.error('Arquivo muito grande', 'O arquivo deve ter no máximo 10MB');
        return;
      }

      setSelectedFile(fileData);
    } else {
      setSelectedFile(null);
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
  };

  return <MensagemFormCard>
      <CardHeader>
        <Body style={{
        fontWeight: '500'
      }}>
          <Icon name="send" size={16} /> Nova Mensagem
        </Body>
      </CardHeader>
      <CardBody>
        <FormContainer onSubmit={handleSubmit}>
          <FormGroup>
            <StyledTextarea rows={3} value={conteudo} onChange={e => setConteudo(e.target.value)} placeholder="Digite sua mensagem..." required />
            
          </FormGroup>

          <FormGroup>
            <FormLabel>
              <Icon name="paperclip" size={14} /> Anexo (opcional)
            </FormLabel>
            <FileInput name="arquivo" value={selectedFile} onChange={handleFileChange} accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif" />
            
            <FormDescription>
              Formatos aceitos: PDF, DOC, DOCX, TXT, JPG, PNG, GIF (máx. 10MB)
            </FormDescription>
          </FormGroup>

          {selectedFile && selectedFile.file && <FilePreview file={selectedFile} onRemove={removeFile} />}

          

          <FormButtonToolbar>
            <ButtonWithLoading variant="primary" type="submit" loading={loading ? 'true' : undefined}>
              
              {loading ? <>
                  <Icon name="loading" size={14} />
                  Enviando...
                </> : <>
                  <Icon name="send" size={14} />
                  Enviar
                </>}
              
            </ButtonWithLoading>
          </FormButtonToolbar>
        </FormContainer>
      </CardBody>
    </MensagemFormCard>;
};

export default MensagemForm; // Estilos

const MensagemFormCard = styled(Card)`
  border: 1px solid ${colorBorder};
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
`;
const CardHeader = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid ${colorBorder};
  background-color: ${colorHover};
  display: flex;
  align-items: center;
  gap: 8px;
`;
const FormLabel = styled.label`
  margin-bottom: 4px;
  display: inline-block;
  color: ${colorTextAdditional};
  font-size: 14px;
  font-weight: 500;
`;
const FormDescription = styled.div`
  font-size: 12px;
  color: ${colorTextAdditional};
  margin-top: 4px;
`;
